import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "../lib/images";
import { Reveal } from "./Reveal";

const sectors = ["Automotive", "Motorsport", "Aeronautico", "Difesa", "Packaging", "Ricerca"];

export const Sectors = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="settori" data-testid="sectors" ref={ref} className="relative overflow-hidden border-y border-white/10">
      <motion.div style={{ y }} className="absolute inset-0 -top-16 -bottom-16">
        <img src={IMAGES.industrialDark} alt="Ambiente industriale Cobi Meccanica" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-zinc-950/80" />
      </motion.div>

      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12 py-28 md:py-40">
        <Reveal>
          <div className="flex items-center gap-3 mb-8">
            <span className="w-8 h-px bg-red-600" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-red-600">Settori</span>
          </div>
          <h2 className="font-display font-black uppercase text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.9] max-w-4xl">
            Dove la precisione fa la differenza
          </h2>
        </Reveal>

        <div className="mt-14 border-t border-white/15">
          {sectors.map((s, i) => (
            <Reveal key={s} delay={i * 0.06}>
              <div
                data-testid={`sector-${s.toLowerCase()}`}
                className="group flex items-center justify-between py-6 md:py-8 border-b border-white/15 cursor-default"
              >
                <div className="flex items-baseline gap-6">
                  <span className="font-mono text-sm text-red-600">{String(i + 1).padStart(2, "0")}</span>
                  <span className="font-display font-bold text-3xl md:text-6xl tracking-tight text-zinc-200 group-hover:text-white group-hover:translate-x-3 transition-all duration-500">
                    {s}
                  </span>
                </div>
                <span className="w-3 h-3 border border-white/30 group-hover:bg-red-600 group-hover:border-red-600 transition-colors duration-500" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
